import {
  Sprite,
  Loader,
  Point,
} from 'pixi.js';
import { isRetina } from '@/scripts/utils';
import gsap from 'gsap';
import Actor from './Actor';
import vars from '../vars';

class Background extends Actor {
  constructor(parent) {
    super(parent);

    this.ref = new Sprite();
    const backgroundSheet = Loader.shared.resources['images/BACKGROUND'].spritesheet.textures;
    this.sprite = new Sprite();
    this.background = new Sprite(backgroundSheet['background.png']);
    this.arch = new Sprite(backgroundSheet['arch.png']);
    this.cloudOne = new Sprite(backgroundSheet['cloud_1.png']);
    this.cloudTwo = new Sprite(backgroundSheet['cloud_2.png']);
    this.sprite.addChild(this.background);
    this.sprite.addChild(this.arch);
    this.sprite.addChild(this.cloudOne);
    this.sprite.addChild(this.cloudTwo);
    this.ref.addChild(this.sprite);

    this.resize();

    this.ref.alpha = 1;

    this.parent.ref.addChild(this.ref);
  }

  resize() {
    this.background.anchor = new Point(0.578, 1);
    if (isRetina()) this.background.scale.set(0.5, 0.5);
    this.arch.anchor = new Point(0.5, 1);
    if (isRetina()) this.arch.scale.set(0.5, 0.5);
    this.cloudOne.anchor = new Point(0.5, 1);
    this.cloudTwo.anchor = new Point(0.5, 1);
    this.cloudOne.position.y = -80;
    this.cloudTwo.position.y = -100;
    this.cloudOne.position.x = 100;
    this.cloudTwo.position.x = -100;
    this.sprite.position.x = vars.layout.STAGE_WIDTH / 2;
    this.sprite.position.y = vars.layout.FRAME_DIFFERENCE_TOP;

    this.arch.position.y += 33;

    gsap.to(this.cloudTwo.position, {
      x: 100,
      ease: 'linear.none',
      duration: 10,
      repeat: -1,
    });
    gsap.to(this.cloudOne.position, {
      x: -100,
      ease: 'linear.none',
      duration: 10,
      repeat: -1,
      delay: 2,
    });
  }

  destroy() {
    this.ref.destroy({ children: true });
  }
}

export default Background;
